export default {"src":"/_next/static/media/BE.cefc3926.svg","height":18,"width":18};